import ModalModulosInscritos from '../components/ModalModulosInscritos.vue';
import { formatearFechaYHoraBoliviana, imprimirProgramaModulo } from '../utils/funciones';

export default {
  components: {
    ModalModulosInscritos,
  },
  computed: {
    textoProgramaModulo() {
      if (!this.inscripcionModuloMasAlto) {
        return '-';
      }

      return `N° ${this.inscripcionModuloMasAlto.programaModulo?.numero}`;
    },
    fechaRegistroProgramaModulo() {
      return formatearFechaYHoraBoliviana(this.inscripcionModuloMasAlto?.fechaRegistro, true);
    },
    tituloProgramaModulo() {
      const programaModuoTexto = imprimirProgramaModulo(this.inscripcionModuloMasAlto);

      return `${programaModuoTexto} ${
        this.fechaRegistroProgramaModulo == '-' ? '' : `- ${this.fechaRegistroProgramaModulo}`
      }`;
    },
  },
  methods: {
    mostrarModal() {
      this.$refs.modalModulosInscritosRef.abrir();
    },
  },
};
